import {
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    Filler,
    Legend,
    LinearScale,
    LineElement,
    PointElement,
    TimeScale,
    Title,
    Tooltip,
} from "chart.js"
import "chartjs-adapter-moment"
import { StandardTimeSeriesGraph } from "routes/sfg20-admin/plugins/system-info/common/components/standard-time-series-graph"
import { Grid2, Tab, Tabs } from "@mui/material"
import { useState } from "react"

ChartJS.register(
    CategoryScale,
    Filler,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    Title,
    Tooltip,
    Legend,
    TimeScale
)

const trends = [
    { group: "Regimes & Schedules", measure: "totalRegimes", title: "Total Regimes" },
    { group: "Regimes & Schedules", measure: "totalSchedulesInAllRegimes", title: "Schedules In All Regimes" },
    { group: "Regimes & Schedules", measure: "totalSchedulesInRegimes", title: "Total Schedules In Use" },
    { group: "Regimes & Schedules", measure: "totalTailoredSchedules", title: "Schedules Tailored" },
    { group: "Regimes & Schedules", measure: "customSchedulesCount", title: "Custom Schedules Created" },
    { group: "Regimes & Schedules", measure: "averageSchedulesPerClient", title: "Average Schedules Per Client" },

    { group: "Sharing & Data", measure: "shareLinkCount", title: "Sharelink Count" },
    { group: "Sharing & Data", measure: "shareLinkUsageCount", title: "Sharelink Usage Count" },
    { group: "Sharing & Data", measure: "apiTokenCount", title: "API Tokens" },
    { group: "System Usage", measure: "sessionsInLastDay", title: "Daily Sessions" },
    { group: "System Usage", measure: "sessionsInLast7Days", title: "Weekly Sessions" },
    { group: "System Usage", measure: "sessionsInLast28Days", title: "Monthly Sessions" },

    { group: "Licence Utilisation", measure: "viewLicences", title: "View Licences" },
    { group: "Licence Utilisation", measure: "collaborateLicences", title: "Collaborate Licences" },
    { group: "Licence Utilisation", measure: "createLicences", title: "Create Licences" },
]

export function Trends() {
    const [currentTab, setCurrentTab] = useState(0)

    function handleChange(event, newValue) {
        setCurrentTab(newValue)
    }

    return (
        <>
            <Tabs variant="scrollable" scrollButtons={false} onChange={handleChange} value={currentTab}>
                <Tab label="Regimes & Schedules"></Tab>
                <Tab label="System Usage" />
                <Tab label="Licence Utilisation" />
                <Tab label="Sharing & Data" />
            </Tabs>

            {currentTab === 0 && <TrendsGroup group="Regimes & Schedules" />}
            {currentTab === 1 && <TrendsGroup group="System Usage" />}
            {currentTab === 2 && <TrendsGroup group="Licence Utilisation" />}
            {currentTab === 3 && <TrendsGroup group="Sharing & Data" />}
        </>
    )
}

export function TrendsGroup({ group }) {
    return (
        <Grid2 container spacing={3} justifyContent="center" alignItems="stretch" mt={4} sx={{ width: "100%" }}>
            {trends
                .filter((trend) => trend.group === group)
                .map((trend, i) => (
                    <Grid2
                        key={`stat_${i}`}
                        size={3}
                        sx={{
                            flexGrow: 1, // Allow the component to expand
                            width: "30%", // Ensure full width
                            height: "100%", // Ensure full height
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <StandardTimeSeriesGraph measure={trend.measure} title={trend.title} />
                    </Grid2>
                ))}
        </Grid2>
    )
}
